import React from 'react';

/**
 * Filas-fantasma para tablas mientras carga la respuesta del servidor.
 *
 *   <SkeletonRow cols={8} />
 *   <SkeletonRow cols={6} count={5} />
 *
 * Render un <tr> con N <td> que contienen una barra animada.
 */
export const SkeletonRow = ({ cols = 6, count = 1 }) => {
  if (count === 1) {
    return (
      <tr className="animate-pulse" data-testid="skeleton-row">
        {Array.from({ length: cols }).map((_, i) => (
          <td key={i} className="px-4 py-3">
            <div className="h-3.5 bg-ink-100 rounded w-[80%]" />
          </td>
        ))}
      </tr>
    );
  }
  return (
    <>
      {Array.from({ length: count }).map((_, k) => (
        <tr key={k} className="animate-pulse" data-testid="skeleton-row">
          {Array.from({ length: cols }).map((_, i) => (
            <td key={i} className="px-4 py-3">
              <div className={`h-3.5 bg-ink-100 rounded ${i === 0 ? 'w-[60%]' : i === cols - 1 ? 'w-[40%]' : 'w-[80%]'}`} />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
};

export default SkeletonRow;
